module.exports = __webpack_public_path__ + "assets/img/sixth_user_s.fdbcb54c.svg";